

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import { UiButton } from '@jtnews/shared/ui';

const LOCAL_STORAGE_KEY = 'UMP_CONSENT_NOTIFICATION';
const TIMEOUT_POPUP = 30000;

@Component({
    name: 'ConsentCookiesNotification',
    components: {
      UiButton,
    },
})
export default class ConsentCookiesNotification extends Vue {
  @Prop({
    required: true,
    type: Boolean,
  })
  isMobile!: boolean;

  isVisible: Boolean = false;
  hideNotificationTimeout: NodeJS.Timeout | null = null;

  store = useStore(this.$store);

  mounted() {
    const hidePopup =
    localStorage.getItem(LOCAL_STORAGE_KEY) === 'true' || sessionStorage.getItem(LOCAL_STORAGE_KEY) === 'true';

    if (hidePopup) {
      return;
    }

    if (this.isMobile) {
      window.addEventListener('scroll', this.handleScroll);
    } else {
      this.showPopup();
    }
  }

  beforeDestroy() {
    if (this.isMobile) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    this.clearHideNotificationTimeout();
  }

  setHideNotificationTimeout() {
    this.hideNotificationTimeout = setTimeout(() => {
      this.isVisible = false;
    }, TIMEOUT_POPUP);
  }

  clearHideNotificationTimeout() {
    if (this.hideNotificationTimeout) {
      clearTimeout(this.hideNotificationTimeout);
    }
  }

  showPopup() {
    this.isVisible = true;
    sessionStorage.setItem(LOCAL_STORAGE_KEY, 'true');

    this.sendNewReachGoal('Просмотр', 'viewPopupCookies');
    this.setHideNotificationTimeout();
  }

  handleScroll() {
    if (window.scrollY > 36 && !this.isVisible) {
      this.showPopup();

      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  onClickButton() {
    localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
    this.isVisible = false;

    this.sendNewReachGoal({ 'Клик': 'Согласие' }, 'clickPopupCookiesButton');

    this.clearHideNotificationTimeout();
  }

  onClickCookiesDocs() {
    this.sendNewReachGoal({ 'Клик': 'Документы' }, 'clickPopupCookiesDocs');
  }

  sendNewReachGoal(valueName: string | Record<string, string>, goalName: string ) {
    const blockType = 'Контент';
    const fieldType = 'Соглашение на обработку кукис';

    this.store.analyticsModule.sendNewReachGoal({
      blockType,
      fieldType,
      valueName,
      goalName,
    });
  }
}
